import { types as t } from 'mobx-state-tree';

export const JobSocial = t
  .model('JobSocial', {
    image: t.maybeNull(t.string),
    title: t.maybeNull(t.string),
    description: t.maybeNull(t.string),
  })
  .volatile(() => ({
    imageFile: null,
  }))
  .actions((self) => {
    let og = {
      image: self.image,
      title: self.title,
      description: self.description,
    };

    return {
      resetAfterSave: () => {
        og.image = self.image;
        og.title = self.title;
        og.description = self.description;
        self.imageFile = null;
      },
      setTitle: (title) => {
        self.title = title;
      },
      setDescription: (desc) => {
        self.description = desc;
      },
      setImageFile: (file, b64) => {
        self.image = b64;
        self.imageFile = file;
      },
      reset: () => {
        self.image = og.image;
        self.title = og.title;
        self.description = og.description;
      },
      resetImageFile: () => {
        self.image = og.image;
        self.imageFile = null;
      },
    };
  });
